export default "__VITE_ASSET__DfWCEkMz__"